import t from "@ext/localization/locale/translate";
import { Tooltip, TooltipContent, TooltipText, TooltipTitle, TooltipTrigger } from "@ui-kit/Tooltip";
import { tv } from "tailwind-variants";
import { useArticleWidthResize } from "./useArticleWidthResize";

// 12px right of the column, from the top of the article down to the actions button, which sits 2em below the
// breadcrumb: ArticleBreadcrumb nests `.article-actions` in `.article-actions`, and each is `bottom: -1em`.
// The article's scroll container cuts off the part above its top.
const handle = tv({
	base: [
		"absolute -right-5 top-[-100vh] bottom-[calc(-2em-4px)] z-[var(--z-index-foreground)] m-0 h-auto w-4",
		"cursor-ew-resize touch-none border-0 bg-transparent outline-none",
		"after:absolute after:inset-y-0 after:left-1/2 after:w-0.5 after:-translate-x-1/2 after:bg-[var(--color-line)]",
		"after:[mask-image:linear-gradient(to_bottom,#000_calc(100%-20px),transparent)]",
		"after:opacity-0 after:transition-opacity hover:after:opacity-100",
		"focus-visible:after:bg-[var(--color-focus)] focus-visible:after:opacity-100",
	],
	variants: {
		resizing: {
			true: "after:bg-[var(--color-focus)] after:opacity-100",
		},
	},
});

const ArticleWidthResizer = () => {
	const { isVisible, isNormal, isResizing, range, handlers } = useArticleWidthResize();
	if (!isVisible) return null;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<hr
					aria-label={t("article.width.label")}
					aria-orientation="vertical"
					aria-valuemax={range.max}
					aria-valuemin={range.min}
					aria-valuenow={range.now}
					className={handle({ resizing: isResizing })}
					data-testid="article-width-resizer"
					tabIndex={0}
					{...handlers}
				/>
			</TooltipTrigger>
			<TooltipContent align="end" side="right">
				<TooltipTitle>{t("article.width.drag")}</TooltipTitle>
				<TooltipText className="block">
					{isNormal ? t("article.width.expand") : t("article.width.reset")}
				</TooltipText>
			</TooltipContent>
		</Tooltip>
	);
};

export default ArticleWidthResizer;
